module.exports = __webpack_public_path__ + "static/img/aboutBanner.a47f0a64.jpg";